import { CommonHelper } from "../helpers";

export default {
  data() {
    return {
      chartProperties: {},
      chartGraphData: [],
      chartData: {},
    };
  },
  computed: {
    barChartProperties() {
      return {
        rangeX: [0, 1000],
        rangeY: [300, 0],
        domainX: [0, 20],
        domainY: [0, 600000],
        tickQuantityY: 5,
        color: ["#1f55af", "#f4c508"],
        legendItems: ["Principal", "Interest"],
        yAxisLabel: "Repayment Amount",
        legendKeyType: "bar",
        areaLegendKey: "bar",
        currencyFormat: ".2s",
        height: 300,
        tickX: 0,
        axisLeftWidth: 75,
        axisRightWidth: 75,
      };
    },
    timeSeriesChartProperties() {
      return {
        domainX: [],
        color: [],
        legendKeyType: "bar",
        height: 10,
        tooltipWidth: 100,
        legendItems: [],
        axisLeftWidth: 0,
        axisRightWidth: 0,
      };
    },
    areaChartProperties() {
      return {
        rangeX: [0, 1000],
        rangeY: [300, 0],
        domainX: [0, 2, 4, 6, 8, 10],
        domainY: [0, 600000],
        tickQuantityY: 5,
        areaLegendItems: "Loan",
        yAxisLabel: "Loan Balance",
        areaLegendKey: "bar",
        lineChartColor: "#2056af",
        currencyFormat: ".2s",
        height: 300,
        tickX: 0,
        axisLeftWidth: 75,
        axisRightWidth: 75,
      };
    },
  },
  methods: {
    GetBarChartProperties(chartData, legendItems, legendColors, yAxisLabel) {
      let roundOffYaxis = CommonHelper.getRoundOffValueForAxis(
        0,
        Math.ceil(chartData.maxYAxis),
        5
      );
      let roundOffYMinaxis =
        chartData.minYAxis > 0
          ? -CommonHelper.getRoundOffValueForAxis(
              0,
              Math.ceil(chartData.minYAxis),
              5
            )
          : 0;
      if (roundOffYaxis < 5) {
        roundOffYaxis = 5;
      }
      this.barChartProperties.legendItems = legendItems;
      this.barChartProperties.color = legendColors;
      this.barChartProperties.yAxisLabel = yAxisLabel;
      this.barChartProperties.domainX = [0, chartData.maxXAxis];
      this.barChartProperties.domainY = [roundOffYMinaxis, roundOffYaxis];
      return this.barChartProperties;
    },
    getTimeSeriesProperties(color) {
      this.timeSeriesChartProperties.domainX = this.getTimeSeriesXAxisData(
        this.projectionYear
      );
      this.timeSeriesChartProperties.color = color;
      return this.timeSeriesChartProperties;
    },
    GetAreaChartProperties(chartData, legendItems, yAxisLabel) {
      let roundOffYaxis = CommonHelper.getRoundOffValueForAxis(
        0,
        Math.ceil(chartData.maxYAxis),
        5
      );
      let roundOffYMinaxis =
        chartData.minYAxis > 0
          ? -CommonHelper.getRoundOffValueForAxis(
              0,
              Math.ceil(chartData.minYAxis),
              5
            )
          : 0;
      if (roundOffYaxis < 5) {
        roundOffYaxis = 5;
      }
      this.areaChartProperties.areaLegendItems = legendItems;
      this.areaChartProperties.domainX = [0, this.projectionYear.Value];
      this.areaChartProperties.yAxisLabel = yAxisLabel;
      this.areaChartProperties.tickX = 0;
      this.areaChartProperties.domainY = [roundOffYMinaxis, roundOffYaxis];
      return this.areaChartProperties;
    },
    getTimeSeriesCoordinate(
      userinputdata,
      isShowRisk,
      projectionYear,
      projectionDate
    ) {
      let timeseriesData = [];
      if (userinputdata == null || userinputdata.length == 0) {
        return timeseriesData;
      }

      let yearRange = this.getTimeSeriesXAxisData(
        projectionYear,
        projectionDate
      );
      if (userinputdata != undefined && userinputdata.length > 0) {
        for (let i = 0; i < userinputdata.length; i++) {
          let statYearMonth = this.getStartMonthYear(
            userinputdata[i].startDate.value,
            yearRange
          );
          let endYearMonth = this.getEndMonthYear(
            userinputdata[i].endDate ? userinputdata[i].endDate.value : 0,
            yearRange
          );
          timeseriesData.push({
            id: i,
            startMonth: statYearMonth[0],
            startYear: statYearMonth[1],
            endMonth: !endYearMonth ? statYearMonth[0] + 1 : endYearMonth[0],
            endYear: !endYearMonth ? statYearMonth[1] : endYearMonth[1],
            description: userinputdata[i].description.value,
            title: CommonHelper.convertIntoCurrencyWithoutDecimal(
              userinputdata[i].amount.value
            ),
            toolTipData: isShowRisk
              ? [
                  {
                    description: "Income",
                    title: CommonHelper.addConstantSymbolInNumber(
                      userinputdata[i].amount.value,
                      "%"
                    ),
                  },
                  {
                    description: "Growth",
                    title: CommonHelper.addConstantSymbolInNumber(
                      userinputdata[i].amount1.value,
                      "%"
                    ),
                  },
                  {
                    description: "Franking",
                    title: CommonHelper.addConstantSymbolInNumber(
                      userinputdata[i].amount2.value,
                      "%"
                    ),
                  },
                ]
              : null,
          });
        }
      }
      return timeseriesData;
    },

    getTimeSeriesXAxisData(projectionYear, projectionDate) {
      let ProjectionDate = new Date(projectionDate);
      let startYear = ProjectionDate.getFullYear();
      return [startYear, startYear + projectionYear.Value];
    },
    getStartMonthYear(date, yearRange) {
      if (!date || date == "") {
        return [1, yearRange[0]];
      } else {
        let monthrange = date.split("/");
        return [parseInt(monthrange[0]), parseInt(monthrange[1])];
      }
    },
    getEndMonthYear(date) {
      if (!date || date == "") {
        return undefined;
      } else {
        let monthrange = date.split("/");
        return [parseInt(monthrange[0]), parseInt(monthrange[1])];
      }
    },
  },
};
